import { apiGet, apiPut, apiDel, apiPost } from 'app/shared-components/util/restAPI';

const CORE_API = 'CoreAPI3';
const PUBLIC_API = 'PublicAPI3';
const API_BASE = '/x3/clienttask';

class ClientTaskService {
  async createTask(taskData) {
    return apiPut(CORE_API, API_BASE, { body: taskData });
  }

  async updateTask(taskId, taskData) {
    return apiPut(CORE_API, `${API_BASE}/${taskId}`, { body: taskData });
  }

  async deleteTask(taskId) {
    return apiDel(CORE_API, `${API_BASE}/${taskId}`, {});
  }

  async getTask(taskId) {
    return apiGet(CORE_API, `${API_BASE}/${taskId}`, {});
  }

  async getTasksByClient(clientId) {
    return apiGet(CORE_API, `${API_BASE}/byclient/${clientId}`, {});
  }

  async getAllTasks() {
    return apiGet(CORE_API, `${API_BASE}/byuser`, {});
  }

  async getMyTasks(userId) {
    return apiGet(CORE_API, `${API_BASE}/byuser/${userId}`, {});
  }

  async generateTaskCode(taskId) {
    return apiGet(CORE_API, `${API_BASE}/${taskId}/generatecode`, {});
  }

  async getTaskAccessLog(taskId) {
    return apiGet(CORE_API, `${API_BASE}/${taskId}/accesslog`, {});
  }

  async getTaskByCode(code, otp = null) {
    const params = new URLSearchParams({ code });
    if (otp) {
      params.append('otp', otp);
    }
    return apiGet(PUBLIC_API, `${API_BASE}/public/bycode?${params.toString()}`, {});
  }

  async submitTask(code, data, sessionToken = null) {
    const submissionData = { ...data };
    if (sessionToken) {
      submissionData.sessionToken = sessionToken;
    }
    return apiPost(PUBLIC_API, `${API_BASE}/public/submit`, {
      body: { code, data: submissionData }
    });
  }

  async resendOtp(code) {
    return apiPost(PUBLIC_API, `${API_BASE}/public/resendotp?code=${code}`, {});
  }

  async getTaskForUser(taskId, otp = null) {
    const params = otp ? `?otp=${otp}` : '';
    return apiGet(CORE_API, `${API_BASE}/${taskId}/foruser${params}`, {});
  }

  async submitTaskForUser(taskId, data, sessionToken = null) {
    const submissionData = { ...data };
    if (sessionToken) {
      submissionData.sessionToken = sessionToken;
    }
    return apiPost(CORE_API, `${API_BASE}/${taskId}/usersubmit`, {
      body: { data: submissionData }
    });
  }

  async filterTasks(filterRequest) {
    return apiPost(CORE_API, `${API_BASE}/filter`, { body: filterRequest });
  }
}

export default new ClientTaskService();